import { Compass, Heart, Sparkles } from "lucide-react";

const PILLARS = [
  {
    icon: Compass,
    title: "Curare",
    text: "Selezioniamo artisti verificati e format solidi. Ogni proposta nel catalogo NMA è testata sul palco.",
  },
  {
    icon: Heart,
    title: "Produrre",
    text: "Ci occupiamo di tutta la filiera: dal service alla logistica, dai permessi SIAE alla comunicazione.",
  },
  {
    icon: Sparkles,
    title: "Amplificare",
    text: "Portiamo cultura, spettacolo e brand nelle piazze, nelle sale e nelle case degli italiani.",
  },
];

export default function MissionSection() {
  return (
    <section
      className="relative border-y av-hairline bg-[#0a0908]"
      data-testid="mission-section"
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-24">
        <div className="max-w-3xl">
          <span className="av-eyebrow" data-testid="mission-eyebrow">
            La nostra mission
          </span>
          <h2 className="font-serif-display text-3xl sm:text-5xl lg:text-6xl mt-4 leading-[1.05]">
            Rendere{" "}
            <span className="italic text-[#E5A93C]">accessibile</span> lo
            spettacolo di qualità a chi organizza eventi.
          </h2>
          <p className="text-[#A39E93] mt-6 text-base sm:text-lg leading-relaxed">
            NMA Agency nasce per unire enti pubblici, comuni, associazioni e
            privati agli artisti giusti — senza intermediari inutili, senza
            sorprese economiche, con un solo interlocutore per tutta la
            produzione. Trasparenza, artigianalità e ossessione per il palco:
            questo è il nostro modo di lavorare.
          </p>
        </div>

        <div className="grid md:grid-cols-3 gap-6 mt-16" data-testid="mission-pillars">
          {PILLARS.map((p, i) => {
            const Icon = p.icon;
            return (
              <div
                key={p.title}
                className="av-card p-8 border-t-2 border-t-[#E5A93C]/40"
                data-testid={`mission-pillar-${i}`}
              >
                <div className="text-[#E5A93C] mb-4">
                  <Icon size={28} />
                </div>
                <h3 className="font-serif-display text-2xl">{p.title}</h3>
                <p className="text-[#A39E93] mt-3 text-sm leading-relaxed">
                  {p.text}
                </p>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
